export const ENDPOINT = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party';
export const TOKEN = 'ddeafb9ff43e79578243d8f031f6e9d8b047ca0e';
